import { forEach, includes } from 'lodash';

import template from './tsz-report-param.html';
import './tsz-report-param.styl';

function controller($rootScope, $mdDialog) {

  const SECTOR_USAGES = ['c1', 'c3', 'c4', 'c5', 'c6', 'ea1'];

  this.onParamChange = (parameter) => {

    // Update all params of sector usages
    if (includes(SECTOR_USAGES, parameter)) {
      const val = this.report[parameter];
      const n = val.substring(val.lastIndexOf('.') + 1);
      forEach(SECTOR_USAGES, (u) => {
        this.report[u] = `${u}.${n}`;
      });
    }

    this.callback();
  };

  // this.showInfoDialog = (parameter) => {
  //   console.log(`clickReportParamInfo event sent: ${parameter}`);
  //   $rootScope.$broadcast('clickReportParamInfo', parameter);
  // };

  this.showInfoDialog = (param) => {

    $mdDialog.show({
      controller: ($scope) => {
        $scope.close = () => {
          $mdDialog.hide();
        };
      },
      controllerAs: 'ctrl',
      templateUrl: `/static/modals/${param}_${this.version}.html`,
      clickOutsideToClose:true,
      fullscreen: false, // Only for -xs, -sm breakpoints.
    });
  };

  this.showTextDialog = (title, text) => {
    $mdDialog.show(
      $mdDialog.alert()
        .clickOutsideToClose(true)
        .title(title)
        .textContent(`${text}`)
        .ariaLabel(title)
        .ok('Ok')
    );
  };

  this.showDivider = (parameter, last) => !parameter.type && !last;
}

export default {
  template,
  controller,
  bindings: {
    param: '<',
    version: '<',
    section: '<',
    callback: '&',
    report: '=',
    editable: '=',
  },
};



// WEBPACK FOOTER //
// ./src/components/tsz-report-param/tsz-report-param.js